import { motion } from 'framer-motion';

export const RainLogo = ({ size = 40, animate = true, className = '' }) => {
  return (
    <motion.div
      className={`gm-rain-logo ${className}`}
      {...(animate ? {
        animate: {
          filter: [
            'drop-shadow(0 0 0px hsl(var(--primary) / 0))',
            'drop-shadow(0 0 8px hsl(var(--primary) / 0.4))',
            'drop-shadow(0 0 0px hsl(var(--primary) / 0))',
          ],
        },
        transition: { duration: 2.5, repeat: Infinity },
      } : {})}
    >
      <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14.6655" cy="14.6655" r="14.6655" fill="#212121"/>
        <path d="M14.5665 2.93311C15.1493 11.8484 25.1879 10.6899 25.1879 14.6671C25.1879 17.9097 20.4194 19.6476 14.5347 19.6476C8.65002 19.6476 3.88153 17.9097 3.88153 14.6671C3.878 10.6899 13.9166 11.8484 14.5029 2.93311C7.70339 2.95077 2.2002 8.21377 2.2002 14.7095C2.2002 21.2053 7.72105 26.4859 14.5347 26.4859C21.3483 26.4859 26.8692 21.2123 26.8692 14.7095C26.8692 8.20671 21.3625 2.95077 14.5665 2.93311Z" fill="#E6FF00"/>
      </svg>
    </motion.div>
  );
};
